import { useEffect, useState } from "react";
type Listener<T> = (val: any) => void;
type Unsubscriber = () => void;

export function useObservable<T>(observable: Observable<T>): any {
    const [val, setVal] = useState(observable.get());

    useEffect(() => {
        return observable.subscribe(setVal);
    }, [observable]);

    return val;
}

export class Observable<T>  {
    private _listeners: Listener<T>[] = [];

    constructor(private _val: any) {}

    get(): T {
        return this._val;
    }

    set(val: T) {
        if (this._val !== val) {
            this._val = val;
            this._listeners.forEach(l => l(val));
        }
    }

    subscribe(listener: Listener<T>): Unsubscriber {
        this._listeners.push(listener);
        return () => {
            this._listeners = this._listeners.filter(l => l !== listener);
        };
    }
}
